export enum DocumentTypeEnum {
  'CC' = 1,
  'CE' = 2,
  'NIT' = 3,
}
